import { device } from '@styles/device.styled';
import Mixin from '@styles/mixin';
import styled, { css } from 'styled-components';

export const FilterWrap = styled.div<{
  isCollapsed?: boolean;
}>`
  ${({ isCollapsed }) =>
    isCollapsed
      ? css`
          ${Mixin.GridLayout({
            gridCount: 5,
            columnGap: '1.6rem',
            rowGap: '0',
            alignItems: 'center',
          })};
        `
      : css`
          display: flex;
          flex-wrap: wrap;
          gap: 1.6rem;
          align-items: center;
        `}
  ${device.mediumScreen} {
    padding: 1.6rem 2rem;
    border-top: 0.1rem solid rgb(217, 218, 219);
  }
`;

export const ResetFilter = styled.a`
  ${({ theme: { FilterBtnStyle } }) =>
    FilterBtnStyle &&
    css`
      font-size: ${FilterBtnStyle.FontSizes.reset};
      font-weight: ${FilterBtnStyle.FontWeights.iconFWNormal};
    `}
  text-decoration: none;
  margin-left: 0.5rem;
`;

export const MoreFilterLink = styled.a`
  ${({ theme: { FilterBtnStyle } }) =>
    FilterBtnStyle &&
    css`
      font-size: ${FilterBtnStyle?.FontSizes?.moreFoterLinkText};
      font-weight: ${FilterBtnStyle.FontWeights.iconFWSemibold};
      margin-left: 0;
      width: max-content;
    `}
`;
